import { getPMResources, getActiveProjectResources } from '../resourceManagement/ResourceService';

export function getPMResourcesIntegrated() {
    return getPMResources();
}

export function getActiveProjectResourcesIntegrated() {
    return getActiveProjectResources();
}